// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Vj-z","sponsoredTooltipWrapper":"Wj-z","sponsoredTooltip":"Xj-z","newCard":"Yj-z"};